/**
 *
 * @param {*} routeName
 *  * este metodo verifica el nombre de la url para despues
 *  * validarla con la del item de la lista o menu
 */
export default function activeRoute(routeName) {
  return window.location.href.indexOf(routeName) > -1 ? true : false;
}
